import { createI18n, DefaultDateTimeFormatSchema } from "vue-i18n";
import en from "../locales/en.json";
import fr from "../locales/fr.json";

const dateFormat: DefaultDateTimeFormatSchema = {
	"date-short": {
		year: "numeric",
		month: "short",
		day: "numeric",
	},
	"time-short": {
		hour: "numeric",
		minute: "numeric",
	},
	time: {
		hour: "numeric",
		minute: "numeric",
		second: "numeric",
	},
	long: {
		year: "numeric",
		month: "numeric",
		day: "numeric",
		hour: "numeric",
		minute: "numeric",
		second: "numeric",
	},
};

const enMessage = { ...en };
const frMessage = { ...fr };

type MessageSchema = typeof enMessage;

declare module "vue-i18n" {
	export interface DefineLocaleMessage extends MessageSchema {}
}

export const i18n = createI18n({
	allowComposition: true,
	locale: import.meta.env.VITE_I18N_LOCALE || "en-CA",
	fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || "en-CA",
	messages: {
		en: enMessage,
		"en-US": enMessage,
		"en-CA": enMessage,
		"fr-CA": frMessage,
		fr: frMessage,
	},
	datetimeFormats: {
		en: dateFormat,
		"en-US": dateFormat,
		"en-CA": dateFormat,
		"fr-CA": dateFormat,
		fr: frMessage,
	},
});
